import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import * as React from 'react';

export interface MultipleIdentifiedFeature {
  id: string;
  title: string;
}

export interface Props {
  features: MultipleIdentifiedFeature[];
  onFeatureSelect: (featureId: string) => void;
  onClose?: () => void;
}

const useStyles = makeStyles(theme => ({
  grow: {
    flexGrow: 1
  },
  button: {
    height: 36,
    padding: theme.spacing(0, 1.5),
    textTransform: 'none'
  }
}));

export const IdentifyMultiple: React.FC<Props> = ({ features, onFeatureSelect, onClose }) => {
  const classes = useStyles();
  const sortedFeatures = [...features].sort((a, b) => {
    const titleA = a.title.toUpperCase();
    const titleB = b.title.toUpperCase();
    if (titleA < titleB) {
      return -1;
    }
    if (titleA > titleB) {
      return 1;
    }
    return 0;
  });

  return (
    <Box display="flex" flexDirection="column" overflow="hidden" bgcolor="background.paper">
      <Box component="div" display="flex" alignItems="center" p={1.5}>
        <Typography
          className={classes.grow}
          align="center"
          component="h4"
          variant="subtitle2"
          noWrap={true}
        >
          Multiple features ({features.length})
        </Typography>
        {onClose && (
          <Box pl={1}>
            <IconButton onClick={onClose} aria-label="close button" size="small">
              <CloseIcon />
            </IconButton>
          </Box>
        )}
      </Box>
      <Divider />
      <Box overflow="auto">
        {sortedFeatures.map((feature, index) => {
          return (
            <React.Fragment key={feature.id}>
              {index !== 0 && <Divider />}
              <Button
                className={classes.button}
                fullWidth={true}
                onClick={onFeatureSelect.bind(null, feature.id)}
              >
                <Typography
                  className={classes.grow}
                  align="left"
                  component="span"
                  variant="body2"
                  noWrap={true}
                >
                  {feature.title}
                </Typography>
              </Button>
            </React.Fragment>
          );
        })}
      </Box>
    </Box>
  );
};

export default IdentifyMultiple;
